<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <bottom-bar v-if="isLoggedIn" />
  </div>
</template>

<script>
import BottomBar from './components/module/interface-components/BottomBar.vue'

export default {
  name: 'app',
  components: {
    BottomBar
  },
  computed: {
    isLoggedIn () {
      return !!this.$store.state.user
    }
  }
}
</script>

<style>
  :root {
    /* Order Status Colors (WCAG AA Compliant) */
    --status-processing: #3B82F6;
    --status-dispatch: #6366F1;
    --status-pick: #06B6D4;
    --status-transit: #8B5CF6;
    --status-attente: #F59E0B;
    --status-drop: #10B981;
    --status-terminee: #059669;
    --status-transferee: #0EA5E9;
    --status-reject: #EF4444;
    --status-inspection: #F97316;
    --status-cancel: #6B7280;
    --status-is-billing: #059669;

    /* KNEye Brand Colors */
    --kne-orange: #f7941e;
    --kne-orange-hover: #e88106;
    --kne-red: #f7132d;
    --kne-green: #32f713;
    --kne-yellow: #f7e21e;
    --kne-dark-grey: #2c2d2f;
    --kne-blue: #1e3e6e;

    /* Late/Warning Indicators */
    --late-color: #B22222;
    --warning-color: #FFA500;
    --on-time-color: #10B981;

    /* UI Colors */
    --bg-primary: #f3f3f4;
    --bg-card: #ffffff;
    --text-primary: #1f2937;
    --text-secondary: #6b7280;
    --border-color: rgba(0, 0, 0, 0.2);
  }

  .fa {
    min-width: 18px;
  }
  p {
    margin-bottom: 0px;
  }
  /* Thin black outline */
  .border {
    border: black solid 1px !important;
    border-radius: 3px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  /* Style for checkboxes in Orders || OrderCurrent, Zone */
  .custom-control-indicator {
    border: solid black 1px;
  }

  /* Vue Google Autocomplete style */
  .pac-container {
    z-index: 1003 !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s !important;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0 !important;
  }
  .slide-fade-enter-active, .slide-fade-leave-active{
    transition: all 500ms;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
    transform: translateY(20px);
  }
  .font-grey{
    color: rgb(90, 90, 90);
  }
  .text-shadow{
    text-shadow: 1px 1px 1px #2E2E2E;
  }
  .box-shadow{
    box-shadow: 0px 5px 8px 0 rgba(0,0,0,0.4);
  }
  .nav-link:hover{
    color: rgba(255,255,255,.75);
  }
  .sidebar {
    position: fixed;
    height: 80%;
    min-width: 9rem;
    padding: 0 .5rem;
    margin-top: 2.3rem;
    padding-bottom: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
    top: 43px;
    bottom: 0;
    /* border-right: solid 1px gainsboro; */
    z-index: 1001; /* Modal: 1000, GoogleMaps: 1000*/
  }

  .sidebar li.nav-item{
    cursor: pointer;
    margin-top: 1rem;
    text-align: left;
  }
  .view{
    width: 100%;
    padding-left: 9.5rem;
    padding-right: .5rem;
    padding-top: .5rem;
  }
  .box-shadow{
    box-shadow: 0 1px 3px rgba(0,0,0,.2), 0 1px 1px rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12)
  }
  .side-box-shadow{
    box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  }
  .bg-blue{
    background-color: #1e3e6e !important;
  }
  .bg-orange{
    background-color: #f7941e !important;
  }
  .bg-lightgrey{
    background-color: #9d9d9d !important;
  }
  .bg-midgrey{
    background-color: #9d9d9d !important;
  }
  .bg-darkgrey{
    background-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
  }
  .bg-red{
    background-color: #d9534f !important;
  }
  .color-orange{
    color: #f7941e !important;
  }
  .color-white{
    color: white !important;
  }
  .color-grey{
    color: rgba(255,255,255,.5) !important;
  }
  .card-header{
    background-color: white;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .btn {
    cursor: pointer;
  }
  .btn-kne-orange{
    background-color: #f7941e !important;
    border-color: #f7941e !important;
    color: white;
  }
  .btn-kne-red{
    background-color: #f7132d !important;
    border-color: #f7132d !important;
    color: white;
  }
  .btn-kne-green{
    background-color: #32f713 !important;
    border-color: #32f713 !important;
    color: #083f00;
  }
  .btn-kne-orange:hover{
    background-color: #e88106 !important;
    border-color: #e88106 !important;
  }
  .btn-kne-yellow {
    background-color: #f7e21e !important;
    border-color: #f7e21e !important;
    color: #4b4101;
  }

  .btn-kne-yellow:hover {
    background-color: #e6d106 !important;
    border-color: #e6d106 !important;
  }
  .card{
    border: 1px solid rgba(0,0,0,.2);
  }
  .bg-darkgrey th{
    background-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
  }
  .kne-title{
    padding: 1.1rem 1rem;
    background-color: #2c2d2f;
    color: white;
    border-bottom: 3px solid #f7941e;
    text-align: center;
  }
  .kne-subtitle {
    padding: 0.6rem 0.5rem;
    background-color: #2c2d2f;
    color: white;
    border-bottom: 2px solid #f7941e;
    text-align: center;
  }
  input[type=date]{
    color: rgb(120, 120, 120);
  }
  body{
    background-color: #f3f3f4;
  }
  th{
    font-weight: normal;
  }
  thead tr{
    border-bottom: 3px solid #f7941e;
  }
  h1, h2 {
    font-weight: normal;
    text-align: center;
  }
  h1{
    font-size: 80px;
  }
  h2{
    font-size: 60px;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }
  #current{
    border-left: 3px solid #f7941e;
  }
  #stats{
    display: flex;
    flex-wrap: wrap;
  }
  .badge{
    margin-top: .65rem;
  }
  .table-fix-width {
    max-width: 15rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .nowrap{
    white-space: nowrap;
  }
  .paginate-links li.active a {
    font-weight: bold;
  }
  .paginate-links li.next:before {
    content: ' | ';
    margin-right: 13px;
    color: #ddd;
  }
  .paginate-links li.disabled a {
    color: #ccc;
    cursor: no-drop;
  }
  .paginate-links li {
    display: inline-block;
    margin: 0 10px;
  }
  .paginate-links li a{
    cursor: pointer;
    color: #f7941e;
  }
  .paginate-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
  }
  .message {
    border-bottom: 1px solid gainsboro;
    cursor: pointer;
  }
  .header{
    margin: 0;
  }
  .btn-badge{
    margin: 0;
    top: 0 !important;
  }

  .table-element_hover {
    transition: all 0.25s ease;
  }

  .dispatch {
    background-color: rgba(140, 192, 227, 0.7);
  }
  .dispatch:hover {
    background-color: rgb(140, 192, 227) !important;
  }
  .drop {
    background-color: rgba(223, 186, 118, 0.85);
  }
  .drop:hover {
    background-color: rgb(223, 186, 118) !important;
  }
  .cancel {
    background-color: rgb(242, 222, 222, 0.7);
  }
  .cancel:hover {
    background-color: rgb(242, 222, 222);
  }
  .waiting {
    background-color: rgba(217, 197, 255, 0.7);
  }
  .waiting:hover {
    background-color: rgb(217, 197, 255) !important;
  }
  .pick {
    background-color: rgba(154, 233, 154, 0.7);
  }
  .pick:hover {
    background-color: rgb(154, 233, 154) !important;
  }
  .transit {
    background-color: rgba(238, 231, 202, 0.7);
  }
  .transit:hover {
    background-color: rgb(238, 231, 202) !important;
  }
  .transfered {
    background-color: rgb(64, 224, 208, 0.7);
  }
  .transfered:hover {
    background-color: rgba(64, 224, 208) !important;
  }
  .reject {
     background-color: rgba(139, 69, 19, 0.9); /* SaddleBrown */
     color: white;
  }
  .reject:hover {
    background-color: rgb(139, 69, 19) !important;
    color: white !important;
  }
  .inspection {
    background-color: rgba(235, 156, 215, 0.7);
  }
  .inspection:hover {
    background-color: rgb(235, 156, 215) !important;
  }
  .late {
    background-color: rgba(178, 34, 34, 0.9);
    color: white;
  }
  .late:hover {
    background-color: rgb(178, 34, 34) !important;
    color: white !important;
  }
  .reject:hover {
    color:grey;
  }
  .sortable {
    cursor: pointer;
  }
  th.sortable:hover {
    color: white !important;
  }
  .brown_text {
    color: rgba(139, 69, 19, 0.9);
  }
  .red_text {
    margin-bottom: 0px;
    color: red;
  }

  .yellow_text {
    color: #f7941e
  }

  .red-border {
    border: 1px red solid;
    border-radius: 3px;
  }

  .red-text {
    color: red;
  }

  .green-border {
    border: 1px rgb(0, 169, 0) solid;
    border-radius: 3px;
  }

  .green-text {
    color: rgb(0, 169, 0);
  }

  label {
    margin-top: 0.5rem;
    margin-bottom: 0px;
  }

  button,
  li p {
    cursor: pointer;
  }

  .me-2 {
    margin-right: 0.2rem;
  }

  .filter-button-group {
    margin-top: .5rem;
    margin-left: .5rem;
    display: flex;
    justify-content: flex-start;
  }

  .drag-handle {
    cursor: grab;
  }

  .shDisp__icon--hover {
    color: rgb(220, 0, 0);
    font-size: 1rem;
    position: relative;
    text-align: center;
  }

  .shDisp__icon--hover .shDisp__icon--tooltip {
    font-family: Arial, Helvetica, sans-serif;
    background: rgb(220, 0, 0);
    bottom: 100%;
    border-radius: 3px;
    color: white;
    margin-bottom: 10px;
    opacity: 0;
    padding: 15px;
    pointer-events: none;
    width: relative;
    -webkit-transform: translateY(10px);
    -moz-transform: translateY(10px);
    -ms-transform: translateY(10px);
    -o-transform: translateY(10px);
    transform: translateY(10px);
    -webkit-transition: all .25s ease-out;
    -moz-transition: all .25s ease-out;
    -ms-transition: all .25s ease-out;
    -o-transition: all .25s ease-out;
    transition: all .25s ease-out;
    -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  }

  .shDisp__icon--tooltip{
    position: absolute;
  }

  .tooltip-dealer-right {
    right: 0px;
  }

  .shDisp__icon--hover:hover .shDisp__icon--tooltip {
    opacity: 1;
    pointer-events: auto;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
  }
  .loader {
    align-content: center;
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3498db; /* Blue */
    border-radius: 50%;
    align-content: center;
    width: 10px;
    height: 10px;
    animation: spin 1s ease-in-out infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }


  input[type="number"]::-webkit-inner-spin-button, 
  input[type="number"]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] { 
    -moz-appearance: textfield;
  }

</style>
